





































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import 'reflect-metadata'
import { Component, Vue, Prop, Ref } from 'vue-property-decorator'
import { DeedCustomerApi, MasterDataApi } from "@/api"
import { IFormCustomer, IFormCustomerValidate } from "@/interface/IDeedCustomerData"
import { isEnglishOnly, isEnglishAndNumberOnly, isNumberOnly, isEmail } from '@/utils/validate'
import DatePicker from '@/components/planning-cr/deed/DatePicker.vue'
import dayjs from 'dayjs'

@Component({
	components: {
		DatePicker
	}
})
export default class DeedCustomerData extends Vue { 
    @Ref() readonly noOrder!: any
    @Prop(Function) public notifcation: any
    @Prop(Function) public openLoading: any

	isCustomerData = false
	masterDataTitle = []
	masterMaritalStatus = [] as any[]
	masterNationality = []
	masterRace = []
	masterCountry = []

	formCustomerP: IFormCustomer = {
		prospectId: 0,
		cbbTitle: null,
		txtFirstnameTH: "",
		txtLastnameTH: "",
		txtFirstnameEN: "",
		txtLastnameEN: "",
		txtCompany: "",
		rdoSex: "",
		txtIdCardOrPassword: "",
		rdoIdCardOrPassword: "",
		cbbMaritalStatus: null,
		pkbirthDate: "",
		txtAge: "",
		cbbNationality: null,
		cbbRace: null,
		rdoProspectType: "",
		txtAddress: "",
		txtVillage: "",
		txtBuilding: "",
		txtFloor: "",
		txtRoomNo: "",
		txtMoo: "",
		txtSoi: "",
		txtRoad: "",
		txtTambol: "",
		txtAmphor: "",
		txtProvinceId: "",
		txtPostCode: "",
		txtMobile1: "",
		txtMobile2: "",
		txtMobile3: "",
		txtTel1: "",
		txtTel2: "",
		txtTel3: "",
		offTel1: "",
		offTel2: "",
		offTelExt1: "",
		offTelExt2: "",
		email1: "",
		email2: "",
		isAllowMail: false,
		isAllowSMS: false,
		isAllowTelephone: false,
		isAllowEmail: false,
		isAllowFax: false,
		addressType: "",
	}

	formCustomerC: IFormCustomer = {
		prospectId: 0,
		cbbTitle: null,
		txtFirstnameTH: "",
		txtLastnameTH: "",
		txtFirstnameEN: "",
		txtLastnameEN: "",
		txtCompany: "",
		rdoSex: "",
		txtIdCardOrPassword: "",
		rdoIdCardOrPassword: "",
		cbbMaritalStatus: null,
		pkbirthDate: "",
		txtAge: "",
		cbbNationality: null,
		cbbRace: null,
		rdoProspectType: "",
		txtAddress: "",
		txtVillage: "",
		txtBuilding: "",
		txtFloor: "",
		txtRoomNo: "",
		txtMoo: "",
		txtSoi: "",
		txtRoad: "",
		txtTambol: "",
		txtAmphor: "",
		txtProvinceId: "",
		txtPostCode: "",
		txtMobile1: "",
		txtMobile2: "",
		txtMobile3: "",
		txtTel1: "",
		txtTel2: "",
		txtTel3: "",
		offTel1: "",
		offTel2: "",
		offTelExt1: "",
		offTelExt2: "",
		email1: "",
		email2: "",
		isAllowMail: false,
		isAllowSMS: false,
		isAllowTelephone: false,
		isAllowEmail: false,
		isAllowFax: false,
		addressType: "",
	}
	countError = 0
	formCustomerValidate: IFormCustomerValidate = {
		cbbTitle: { disabled: false, error: false, message: "" },
		txtFirstnameTH: { disabled: true, error: false, message: "" },
		txtLastnameTH: { disabled: true, error: false, message: "" },
		txtFirstnameEN: { disabled: true, error: false, message: "" },
		txtLastnameEN: { disabled: true, error: false, message: "" },
		rdoSex: { disabled: true, error: false, message: "" },
		txtIdCardOrPassword: { disabled: true, error: false, message: "" },
		rdoIdCardOrPassword: { disabled: true, error: false, message: "" },
		cbbMaritalStatus: { disabled: true, error: false, message: "" },
		pkbirthDate: { disabled: true, error: false, message: "" },
		txtAge: { disabled: true, error: false, message: "" },
		cbbNationality: { disabled: true, error: false, message: "" },
		cbbRace: { disabled: true, error: false, message: "" },
		rdoProspectType: { disabled: true, error: false, message: "" },
		txtMobileC1: { disabled: true, error: false, message: "" },
		emailC1: { disabled: true, error: false, message: "" },
		txtMobileP1: { disabled: true, error: false, message: "" },
		emailP1: { disabled: true, error: false, message: "" },
	}

	isBtnSave = true

	async setTextBox (prospect: any[]) {
		this.openLoading(true)
		await this.setMaster()
		this.isCustomerData = true

		let getMaritalStatus: any = this.masterMaritalStatus.filter((x: any) => x.abbr === prospect[0].maritalStatus).length === 0 ? null : this.masterMaritalStatus.filter((x: any) => x.abbr === prospect[0].maritalStatus)[0]
		let getTitle: any = this.masterDataTitle.filter((x: any) => x.id === prospect[0].titleId).length === 0 ? null : this.masterDataTitle.filter((x: any) => x.id === prospect[0].titleId)[0]
		let getNationality: any = this.masterNationality.filter((x: any) => x.id === prospect[0].nationalityId).length === 0 ? null : this.masterNationality.filter((x: any) => x.id === prospect[0].nationalityId)[0]
		let getRace: any = this.masterRace.filter((x: any) => x.id === prospect[0].raceId).length === 0 ? null : this.masterRace.filter((x: any) => x.id === prospect[0].raceId)[0]
		
		this.formCustomerC.pkbirthDate = "";
		
		const prospectAddressTypeC = prospect.find(x => x.addressType == "C")
		if (prospectAddressTypeC != undefined)
		{
			this.formCustomerC = {
				prospectId: prospectAddressTypeC.prospectId,
				cbbTitle: getTitle,
				txtFirstnameTH: prospectAddressTypeC.firstnameTH.trim(),
				txtLastnameTH: prospectAddressTypeC.lastnameTH.trim(),
				txtFirstnameEN: prospectAddressTypeC.firstnameEN.trim(),
				txtLastnameEN: prospectAddressTypeC.lastnameEN.trim(),
				txtCompany: prospectAddressTypeC.company,
				rdoSex: prospectAddressTypeC.sex.trim(),
				txtIdCardOrPassword: prospectAddressTypeC.idCard.trim(),
				rdoIdCardOrPassword: this.setIdCardOrPassword(prospectAddressTypeC.idCard.trim()),
				cbbMaritalStatus: getMaritalStatus,
				pkbirthDate: this.setDate(prospectAddressTypeC.birthDate),
				txtAge: this.calAge(prospectAddressTypeC.birthDate),
				cbbNationality: getNationality,
				cbbRace: getRace,
				rdoProspectType: prospectAddressTypeC.prospectType,
				txtAddress: prospectAddressTypeC.address,
				txtVillage: prospectAddressTypeC.village,
				txtBuilding: prospectAddressTypeC.building,
				txtFloor: prospectAddressTypeC.floor,
				txtRoomNo: prospectAddressTypeC.roomNo,
				txtMoo: prospectAddressTypeC.moo,
				txtSoi: prospectAddressTypeC.soi,
				txtRoad: prospectAddressTypeC.street,
				txtTambol: prospectAddressTypeC.tambol,
				txtAmphor: prospectAddressTypeC.amphor,
				txtProvinceId: prospectAddressTypeC.province,
				txtPostCode: prospectAddressTypeC.postCode,
				txtMobile1: prospectAddressTypeC.mobile1,
				txtMobile2: prospectAddressTypeC.mobile2,
				txtMobile3: prospectAddressTypeC.mobile3,
				txtTel1: prospectAddressTypeC.tel1,
				txtTel2: prospectAddressTypeC.tel2,
				txtTel3: prospectAddressTypeC.tel3,
				offTel1: prospectAddressTypeC.offTel1,
				offTel2: prospectAddressTypeC.offTel2,
				offTelExt1: prospectAddressTypeC.offTelExt1,
				offTelExt2: prospectAddressTypeC.offTelExt2,
				email1: prospectAddressTypeC.email1.trim().toLowerCase() == "n/a" ? "" : prospectAddressTypeC.email1.trim(),
				email2: prospectAddressTypeC.email2,
				isAllowMail: prospectAddressTypeC.allowMail === 'Y' ? true : false,
				isAllowSMS: prospectAddressTypeC.allowSMS === 'Y' ? true : false,
				isAllowTelephone: prospectAddressTypeC.allowTelephone === 'Y' ? true : false,
				isAllowEmail: prospectAddressTypeC.allowEmail === 'Y' ? true : false,
				isAllowFax	: prospectAddressTypeC.allowFax === 'Y' ? true : false,
				addressType : prospectAddressTypeC.addressType,
			}
		}
		

		const prospectAddressTypeP = prospect.find(x => x.addressType == "P")
		if (prospectAddressTypeP != undefined)
		{
			this.formCustomerP = {
				prospectId: prospectAddressTypeP.prospectId,
				cbbTitle: getTitle,
				txtFirstnameTH: prospectAddressTypeP.firstnameTH.trim(),
				txtLastnameTH: prospectAddressTypeP.lastnameTH.trim(),
				txtFirstnameEN: prospectAddressTypeP.firstnameEN.trim(),
				txtLastnameEN: prospectAddressTypeP.lastnameEN.trim(),
				txtCompany: prospectAddressTypeC.company,
				rdoSex: prospectAddressTypeP.sex.trim(),
				txtIdCardOrPassword: prospectAddressTypeP.idCard.trim(),
				rdoIdCardOrPassword: this.setIdCardOrPassword(prospectAddressTypeP.idCard.trim()),
				cbbMaritalStatus: getMaritalStatus,
				pkbirthDate: this.setDate(prospectAddressTypeP.birthDate),
				txtAge: this.calAge(prospectAddressTypeP.birthDate),
				cbbNationality: getNationality,
				cbbRace: getRace,
				rdoProspectType: prospectAddressTypeP.prospectType,
				txtAddress: prospectAddressTypeP.address,
				txtVillage: prospectAddressTypeP.village,
				txtBuilding: prospectAddressTypeP.building,
				txtFloor: prospectAddressTypeP.floor,
				txtRoomNo: prospectAddressTypeP.roomNo,
				txtMoo: prospectAddressTypeP.moo,
				txtSoi: prospectAddressTypeP.soi,
				txtRoad: prospectAddressTypeP.street,
				txtTambol: prospectAddressTypeP.tambol,
				txtAmphor: prospectAddressTypeP.amphor,
				txtProvinceId: prospectAddressTypeP.province,
				txtPostCode: prospectAddressTypeP.postCode,
				txtMobile1: prospectAddressTypeP.mobile1,
				txtMobile2: prospectAddressTypeP.mobile2,
				txtMobile3: prospectAddressTypeP.mobile3,
				txtTel1: prospectAddressTypeP.tel1,
				txtTel2: prospectAddressTypeP.tel2,
				txtTel3: prospectAddressTypeP.tel3,
				offTel1: prospectAddressTypeP.offTel1,
				offTel2: prospectAddressTypeP.offTel2,
				offTelExt1: prospectAddressTypeP.offTelExt1,
				offTelExt2: prospectAddressTypeP.offTelExt2,
				email1: prospectAddressTypeP.email1.trim().toLowerCase() == "n/a" ? "" : prospectAddressTypeP.email1.trim(),
				email2: prospectAddressTypeP.email2,
				isAllowMail: prospectAddressTypeP.allowMail === 'Y' ? true : false,
				isAllowSMS: prospectAddressTypeP.allowSMS === 'Y' ? true : false,
				isAllowTelephone: prospectAddressTypeP.allowTelephone === 'Y' ? true : false,
				isAllowEmail: prospectAddressTypeP.allowEmail === 'Y' ? true : false,
				isAllowFax	: prospectAddressTypeP.allowFax === 'Y' ? true : false,
				addressType : prospectAddressTypeP.addressType,
			}
		}
		else{
			this.formCustomerP = {
				prospectId: 0,
				cbbTitle: "",
				txtFirstnameTH: "",
				txtLastnameTH: "",
				txtFirstnameEN: "",
				txtLastnameEN: "",
				txtCompany: "",
				rdoSex: "",
				txtIdCardOrPassword: "",
				rdoIdCardOrPassword: "",
				cbbMaritalStatus: "",
				pkbirthDate: "",
				txtAge: "",
				cbbNationality: "",
				cbbRace: "",
				rdoProspectType: "",
				txtAddress: "",
				txtVillage: "",
				txtBuilding: "",
				txtFloor: "",
				txtRoomNo: "",
				txtMoo: "",
				txtSoi: "",
				txtRoad: "",
				txtTambol: "",
				txtAmphor: "",
				txtProvinceId: "",
				txtPostCode: "",
				txtMobile1: "",
				txtMobile2: "",
				txtMobile3: "",
				txtTel1: "",
				txtTel2: "",
				txtTel3: "",
				offTel1: "",
				offTel2: "",
				offTelExt1: "",
				offTelExt2: "",
				email1: "",
				email2: "",
				isAllowMail: false,
				isAllowSMS: false,
				isAllowTelephone: false,
				isAllowEmail: false,
				isAllowFax	: false,
				addressType: ""
			}
		}
		

		this.isError()
		this.openLoading(false)
	}

	async btnSave () {
		this.changeFormCustomer()
		if (this.countError > 0) {
			this.notifcation("กรุณากรอกข้อมูลให้ถูกต้อง", "warning")
			return
		}
		const jsonUpdateCustomer = {
			prospectId: this.formCustomerC.prospectId,
			titleId: this.formCustomerC.cbbTitle.id,
			sex: this.formCustomerC.rdoSex,
			firstnameTH: this.formCustomerC.txtFirstnameTH.trim(),
			lastnameTH: this.formCustomerC.txtLastnameTH.trim(),
			firstnameEN: this.formCustomerC.txtFirstnameEN.trim(),
			lastnameEN: this.formCustomerC.txtLastnameEN.trim(),
			idCardOrPassword: this.formCustomerC.txtIdCardOrPassword,
			maritalStatus: this.formCustomerC.cbbMaritalStatus.abbr,
			birthDate: this.formCustomerC.pkbirthDate,
			age: this.formCustomerC.txtAge,
			nationalityId: this.formCustomerC.cbbNationality.id,
			raceId: this.formCustomerC.cbbRace.id,
			mobileC1: this.formCustomerC.txtMobile1,
			emailC1: this.formCustomerC.email1.trim(),
			mobileP1: this.formCustomerP.txtMobile1,
			emailP1: this.formCustomerP.email1.trim(),
		}
		this.openLoading(true)
		const result = await DeedCustomerApi.UpdateDeedProspectDetail(jsonUpdateCustomer)
		if (result === "updated") this.notifcation("อัพเดทข้อมูลสำเร็จ", "success")
		if (result !== "updated") this.notifcation("ไม่สามารถอัพเดทข้อมูลได้กรุณาลองใหม่", "warning")
		this.openLoading(false)
	}

	updateStatePkbirthDate (v: any) {
		this.formCustomerC.pkbirthDate = v
		this.formCustomerC.txtAge = this.calAge(v)
		this.changeFormCustomer()
	}

	changeFormCustomer () {
		let countError = 0
		if (this.formCustomerC.cbbTitle == null) {
			this.formCustomerValidate.cbbTitle.error = true
			this.formCustomerValidate.cbbTitle.disabled = false
			this.formCustomerValidate.cbbTitle.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.cbbTitle.error = false
			this.formCustomerValidate.cbbTitle.message = ""
		}

		if (this.formCustomerC.rdoSex === "") {
			this.formCustomerValidate.rdoSex.error = true
			this.formCustomerValidate.rdoSex.disabled = false
			this.formCustomerValidate.rdoSex.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.rdoSex.error = false
			this.formCustomerValidate.rdoSex.message = ""
		}

		if (this.formCustomerC.txtFirstnameTH === "") {
			this.formCustomerValidate.txtFirstnameTH.error = true
			this.formCustomerValidate.txtFirstnameTH.disabled = false
			this.formCustomerValidate.txtFirstnameTH.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.txtFirstnameTH.error = false
			this.formCustomerValidate.txtFirstnameTH.message = ""
		}

		if (this.formCustomerC.txtLastnameTH === "") {
			this.formCustomerValidate.txtLastnameTH.error = true
			this.formCustomerValidate.txtLastnameTH.disabled = false
			this.formCustomerValidate.txtLastnameTH.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.txtLastnameTH.error = false
			this.formCustomerValidate.txtLastnameTH.message = ""
		}

		if (this.formCustomerC.txtFirstnameEN === "" || isEnglishOnly(this.formCustomerC.txtFirstnameEN) === false) {
			this.formCustomerValidate.txtFirstnameEN.error = true
			this.formCustomerValidate.txtFirstnameEN.disabled = false
			this.formCustomerValidate.txtFirstnameEN.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.txtFirstnameEN.error = false
			this.formCustomerValidate.txtFirstnameEN.message = ""
		}

		if (this.formCustomerC.txtLastnameEN === "" || isEnglishOnly(this.formCustomerC.txtLastnameEN) === false) {
			this.formCustomerValidate.txtLastnameEN.error = true
			this.formCustomerValidate.txtLastnameEN.disabled = false
			this.formCustomerValidate.txtLastnameEN.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.txtLastnameEN.error = false
			this.formCustomerValidate.txtLastnameEN.message = ""
		}

		if (this.formCustomerC.txtIdCardOrPassword === ""|| isEnglishAndNumberOnly(this.formCustomerC.txtIdCardOrPassword) === false) {
			this.formCustomerValidate.txtIdCardOrPassword.error = true
			this.formCustomerValidate.txtIdCardOrPassword.disabled = false
			this.formCustomerValidate.txtIdCardOrPassword.message = "กรุณาแก้ไขให้ถูกต้อง"
			this.formCustomerValidate.rdoIdCardOrPassword.disabled = false
			countError++
		} else {
			this.formCustomerValidate.txtIdCardOrPassword.error = false
			this.formCustomerValidate.txtIdCardOrPassword.message = ""
		}

		if (this.formCustomerC.cbbMaritalStatus === null) {
			this.formCustomerValidate.cbbMaritalStatus.error = true
			this.formCustomerValidate.cbbMaritalStatus.disabled = false
			this.formCustomerValidate.cbbMaritalStatus.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.cbbMaritalStatus.error = false
			this.formCustomerValidate.cbbMaritalStatus.message = ""
		}

		if (this.formCustomerC.pkbirthDate === "") {
			this.formCustomerValidate.pkbirthDate.error = true
			this.formCustomerValidate.pkbirthDate.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.pkbirthDate.error = false
			this.formCustomerValidate.pkbirthDate.message = ""
		}

		if (this.formCustomerC.cbbNationality == null) {
			this.formCustomerValidate.cbbNationality.error = true
			this.formCustomerValidate.cbbNationality.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.cbbNationality.error = false
			this.formCustomerValidate.cbbNationality.message = ""
		}

		if (this.formCustomerC.cbbRace == null) {
			this.formCustomerValidate.cbbRace.error = true
			this.formCustomerValidate.cbbRace.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.cbbRace.error = false
			this.formCustomerValidate.cbbRace.message = ""
		}

		if (this.formCustomerP.txtMobile1 === "" || isNumberOnly(this.formCustomerP.txtMobile1) === false) {
			this.formCustomerValidate.txtMobileP1.error = true
			this.formCustomerValidate.txtMobileP1.message = "กรุณาแก้ไขให้ถูกต้อง"
		} else {
			this.formCustomerValidate.txtMobileP1.error = false
			this.formCustomerValidate.txtMobileP1.message = ""
		}

		if (this.formCustomerC.txtMobile1 === "" || isNumberOnly(this.formCustomerC.txtMobile1) === false) {
			this.formCustomerValidate.txtMobileC1.error = true
			this.formCustomerValidate.txtMobileC1.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.txtMobileC1.error = false
			this.formCustomerValidate.txtMobileC1.message = ""
		}

		if (this.formCustomerP.email1 !== "") {
			if (isEmail(this.formCustomerP.email1) === false) {
				this.formCustomerValidate.emailP1.error = true
				this.formCustomerValidate.emailP1.message = "กรุณาแก้ไขให้ถูกต้อง"
				countError++
			} else {
				this.formCustomerValidate.emailP1.error = false
				this.formCustomerValidate.emailP1.message = ""
			}
		}

		if (this.formCustomerC.email1 !== "") {
			if (isEmail(this.formCustomerC.email1) === false) {
				this.formCustomerValidate.emailC1.error = true
				this.formCustomerValidate.emailC1.message = "กรุณาแก้ไขให้ถูกต้อง"
				countError++
			} else {
				this.formCustomerValidate.emailC1.error = false
				this.formCustomerValidate.emailC1.message = ""
			}
		}

		

		this.countError = countError
	}

	isError () {
		let countError = 0
		if (this.formCustomerC.cbbTitle == null) {
			this.formCustomerValidate.cbbTitle.error = true
			this.formCustomerValidate.cbbTitle.disabled = false
			this.formCustomerValidate.cbbTitle.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.cbbTitle.error = false
			this.formCustomerValidate.cbbTitle.disabled = true
			this.formCustomerValidate.cbbTitle.message = ""
		}

		if (this.formCustomerC.rdoSex === "") {
			this.formCustomerValidate.rdoSex.error = true
			this.formCustomerValidate.rdoSex.disabled = false
			this.formCustomerValidate.rdoSex.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.rdoSex.error = false
			this.formCustomerValidate.rdoSex.disabled = true
			this.formCustomerValidate.rdoSex.message = ""
		}

		if (this.formCustomerC.txtFirstnameTH === "") {
			this.formCustomerValidate.txtFirstnameTH.error = true
			this.formCustomerValidate.txtFirstnameTH.disabled = false
			this.formCustomerValidate.txtFirstnameTH.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.txtFirstnameTH.error = false
			this.formCustomerValidate.txtFirstnameTH.disabled = true
			this.formCustomerValidate.txtFirstnameTH.message = ""
		}

		if (this.formCustomerC.txtLastnameTH === "") {
			this.formCustomerValidate.txtLastnameTH.error = true
			this.formCustomerValidate.txtLastnameTH.disabled = false
			this.formCustomerValidate.txtLastnameTH.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.txtLastnameTH.error = false
			this.formCustomerValidate.txtLastnameTH.disabled = true
			this.formCustomerValidate.txtLastnameTH.message = ""
		}

		if (this.formCustomerC.txtFirstnameEN === "") {
			this.formCustomerValidate.txtFirstnameEN.error = true
			this.formCustomerValidate.txtFirstnameEN.disabled = false
			this.formCustomerValidate.txtFirstnameEN.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.txtFirstnameEN.error = false
			this.formCustomerValidate.txtFirstnameEN.disabled = true
			this.formCustomerValidate.txtFirstnameEN.message = ""
		}

		if (this.formCustomerC.txtLastnameEN === "") {
			this.formCustomerValidate.txtLastnameEN.error = true
			this.formCustomerValidate.txtLastnameEN.disabled = false
			this.formCustomerValidate.txtLastnameEN.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.txtLastnameEN.error = false
			this.formCustomerValidate.txtLastnameEN.disabled = true
			this.formCustomerValidate.txtLastnameEN.message = ""
		}

		if (this.formCustomerC.txtIdCardOrPassword === "") {
			this.formCustomerValidate.txtIdCardOrPassword.error = true
			this.formCustomerValidate.txtIdCardOrPassword.disabled = false
			this.formCustomerValidate.txtIdCardOrPassword.message = "กรุณาแก้ไขให้ถูกต้อง"
			this.formCustomerValidate.rdoIdCardOrPassword.disabled = false
			countError++
		} else {
			this.formCustomerValidate.txtIdCardOrPassword.error = false
			this.formCustomerValidate.txtIdCardOrPassword.disabled = true
			this.formCustomerValidate.txtIdCardOrPassword.message = ""
			this.formCustomerValidate.rdoIdCardOrPassword.disabled = true
		}

		if (this.formCustomerC.cbbMaritalStatus == null) {
			this.formCustomerValidate.cbbMaritalStatus.error = true
			this.formCustomerValidate.cbbMaritalStatus.disabled = false
			this.formCustomerValidate.cbbMaritalStatus.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.cbbMaritalStatus.error = false
			this.formCustomerValidate.cbbMaritalStatus.disabled = true
			this.formCustomerValidate.cbbMaritalStatus.message = ""
		}

		if (this.formCustomerC.pkbirthDate === "") {
			this.formCustomerValidate.pkbirthDate.error = true
			this.formCustomerValidate.pkbirthDate.disabled = false
			this.formCustomerValidate.pkbirthDate.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.pkbirthDate.error = false
			this.formCustomerValidate.pkbirthDate.disabled = true
			this.formCustomerValidate.pkbirthDate.message = ""
		}

		if (this.formCustomerC.cbbNationality == null) {
			this.formCustomerValidate.cbbNationality.error = true
			this.formCustomerValidate.cbbNationality.disabled = false
			this.formCustomerValidate.cbbNationality.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.cbbNationality.error = false
			this.formCustomerValidate.cbbNationality.disabled = true
			this.formCustomerValidate.cbbNationality.message = ""
		}

		if (this.formCustomerC.cbbRace == null) {
			this.formCustomerValidate.cbbRace.error = true
			this.formCustomerValidate.cbbRace.disabled = false
			this.formCustomerValidate.cbbRace.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.cbbRace.error = false
			this.formCustomerValidate.cbbRace.disabled = true
			this.formCustomerValidate.cbbRace.message = ""
		}

		if (this.formCustomerP.txtMobile1 === "") {
			this.formCustomerValidate.txtMobileP1.error = true
			this.formCustomerValidate.txtMobileP1.disabled = false
			this.formCustomerValidate.txtMobileP1.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.txtMobileP1.error = false
			this.formCustomerValidate.txtMobileP1.disabled = true
			this.formCustomerValidate.txtMobileP1.message = ""
		}

		if (this.formCustomerC.txtMobile1 === "") {
			this.formCustomerValidate.txtMobileC1.error = true
			this.formCustomerValidate.txtMobileC1.disabled = false
			this.formCustomerValidate.txtMobileC1.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.txtMobileC1.error = false
			this.formCustomerValidate.txtMobileC1.disabled = true
			this.formCustomerValidate.txtMobileC1.message = ""
		}

		if (this.formCustomerC.email1 === "") {
			this.formCustomerValidate.emailC1.error = true
			this.formCustomerValidate.emailC1.disabled = false
			this.formCustomerValidate.emailC1.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.emailC1.error = false
			this.formCustomerValidate.emailC1.disabled = true
			this.formCustomerValidate.emailC1.message = ""
		}

		if (this.formCustomerP.email1 === "") {
			this.formCustomerValidate.emailP1.error = true
			this.formCustomerValidate.emailP1.disabled = false
			this.formCustomerValidate.emailP1.message = "กรุณาแก้ไขให้ถูกต้อง"
			countError++
		} else {
			this.formCustomerValidate.emailP1.error = false
			this.formCustomerValidate.emailP1.disabled = true
			this.formCustomerValidate.emailP1.message = ""
		}

		this.countError = countError
	}

	setDate (date: string) {
		if (date === "") return ""
		const [d, m, y] = date.split("/")
		return `${y}-${m}-${d}`
	}

	async setMaster () {
		const masterTitle = await MasterDataApi.GetMasterTitle()
		this.masterDataTitle = masterTitle
		const maritalStatus: any[] = await MasterDataApi.GetMaritalStatus()
		this.masterMaritalStatus = maritalStatus
		const nationality = await MasterDataApi.GetNationality()
		this.masterNationality = nationality
		const race = await MasterDataApi.GetRace()
		this.masterRace = race
		const country = await MasterDataApi.GetCountry()
		this.masterCountry = country
	}

	calAge (date: string) {
		
		if (date != "") {
			let useDate: any = ""

			if (date.split("/").length === 3) {
				const [d, m, y ] = date.split("/")
				useDate = `${y}/${m}/${d}`
			}
			
			if (date.split("-").length === 3) {
				const [y, m, d ] = date.split("-")
				useDate = `${y}/${m}/${d}`
			}

			console.log('useDate', useDate)
			if (useDate != "") {
				const date1 = dayjs(`${dayjs(useDate).format('YYYY-MM-DD')}`)
				const date2 = dayjs()
				console.log(date1)
				console.log(date2)
				console.log('date2', `${date2.diff(date1, 'y')}`)
				return `${date2.diff(date1, 'y')}`
			}
		}
		return ""
	}

	setIdCardOrPassword (idCard: any) {
		if (idCard.length > 12) {
			return "idCard"
		} else if (idCard !== "") {
			return "passport"
		} else {
			return "idCard"
		}
	}
}
